import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ExpertSourcesActions,
  ExpertSourcesAPIActions,
} from '@techspert-io/expert-sources';
import {
  ConnectPhase,
  ExpertActions,
  ExpertAPIActions,
  IQueryExpertSearchRequest,
} from '@techspert-io/experts';
import { OpportunityActions } from '@techspert-io/opportunities';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OpportunityExpertsEffects {
  getSources$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OpportunityActions.fetchOpportunity),
      filter(({ options }) => options?.fetchSearches),
      map(({ opportunityId }) =>
        ExpertSourcesActions.queryExpertSourcesByOpportunity({
          opportunityId,
          options: { fetchSearches: true },
        })
      )
    );
  });

  getSearchesStats$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ExpertSourcesAPIActions.queryExpertSourcesByOpportunitySuccess),
      filter(({ options }) => options?.fetchSearches),
      map(({ opportunityId }) =>
        ExpertActions.fetchExpertSearchesStats({
          opportunityId: opportunityId,
        })
      )
    );
  });

  getSearches$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ExpertAPIActions.fetchExpertSearchesStatsSuccess),
      map(({ response, opportunityId }) => {
        const phasesToCollect: ConnectPhase[] = [
          'outreach',
          'screener',
          'sentToClient',
          'accepted',
          'scheduled',
          'completed',
        ];

        const batchPhaseMap = response.reduce<
          IQueryExpertSearchRequest['batches']
        >((acc, curr) => {
          const fewerThan50Experts =
            Object.values(curr.totals).reduce(
              (acc, curr) => (acc += curr),
              0
            ) <= 50;

          if (fewerThan50Experts) {
            return [
              ...acc,
              {
                batchId: curr.batchId,
                batchName: curr.batchName,
                expertSourceIds: curr.sourceIds,
              },
            ];
          }

          const someExpertsResponded = phasesToCollect.some(
            (phase) => curr.totals[phase]
          );

          if (someExpertsResponded) {
            return [
              ...acc,
              {
                batchId: curr.batchId,
                batchName: curr.batchName,
                expertSourceIds: curr.sourceIds,
                fromPhase: 'outreach',
              },
            ];
          }

          return acc;
        }, []);

        return ExpertActions.fetchExpertSearches({
          query: {
            opportunityId: opportunityId,
            batches: batchPhaseMap,
          },
        });
      })
    );
  });

  constructor(private actions$: Actions) {}
}
